import React from "react";
import { useAuth } from "@/lib/auth";
import { Sparkles } from "lucide-react";

export default function DemoModeBanner() {
    const { user } = useAuth();
    if (!user?.is_demo_environment) return null;

    return (
        <div
            data-testid="demo-mode-banner"
            className="fixed top-[81px] left-0 right-0 z-40 h-8 bg-gradient-to-r from-amber-600 via-amber-500 to-amber-600 text-ink-950 text-[11px] sm:text-xs font-semibold tracking-wide uppercase flex items-center justify-center gap-2 shadow-md"
        >
            <Sparkles size={12} className="shrink-0" />
            <span>Modalità Dimostrativa — Ambiente Protetto</span>
        </div>
    );
}
